/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";

interface LoaderProps {
  loader: LoaderState;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error } }) => {
  if (loading) {
    return (
      <React.Fragment>
        <Spinner />
      </React.Fragment>
    );
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>Could not load Social Accounts. Please refresh page.</p>
        </React.Fragment>
      );
    }
  }

  return (
    <p>An error occurred while performing this operation. Please try again later, or contact support if it persists.</p>
  );
};

export default Loader;
